// extracted by mini-css-extract-plugin
export default {"root":"AfA691jUll5HIBaWs53q","info":"mlEUAQRl6ApL6HND4_nV"};